import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormArray, FormControl, Form, FormBuilder, Validators } from '@angular/forms';


import {apiUrl}  from '../global';

import { ResponseApi } from '../response-api';
import { Break8Service } from '../break8.service';
import { SharedService } from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'break8',
  templateUrl: 'break8.component.html',
  styleUrls: ['break8.component.css'],
})
export class Break8Component implements OnInit, AfterViewChecked {
  responseApis: ResponseApi[];
  loginAttempt: ResponseApi[];
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  currentQuestion: any;
  baseUrl: any;
  lengthOfQuiz: any;
  orderInQuiz:any;

  slideIn: boolean;


  genericVal: any;
  nextQuestion: any;

  fadeOut: any;
  fadeInShow: any;

  constructor(private router: Router, private quizService: Break8Service, private route: ActivatedRoute, private sharedService: SharedService) {
    this.fadeOut = false;
    console.log(11111)
    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
    //this.getUrl;
    this.currentQuestion = false;
    this.slideIn = false;
    this.nextQuestion = false;
  }
  setBackgroundColor(backgroundColor: string):void{
    this.sharedService.setBackgroundColor(backgroundColor);
  }
  getBackgroundColor(){
    return this.sharedService.getVal('backgroundColor');
  }
  getUrl(url: string): void {
    this.quizService
      .getUrl(url)
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){

          this.router.navigate(['page-not-found']);
        }
        else{
          var domain = this.responseApis[0]['data']['generalDetails'][0]['has_domain'];
          var userListType = this.responseApis[0]['data']['generalDetails'][0]['user_list_type'];
          var hasUserList = this.responseApis[0]['data']['generalDetails'][0]['has_user_list'];

          if(domain == 1){
            this.domainList = this.responseApis[0]['data']['domains'];
          }
          else{
            this.domainList = false;
          }

          if(userListType == 'email'){
            this.userListType = true;
          }
          else{
            this.userListType = false;
          }

          if(hasUserList == 1){
            this.hasUserList = true;
          }
          else{
            this.hasUserList = false;
          }


          //has list - email
          if(this.hasUserList && this.userListType){
            this.form = new FormGroup({
              email: new FormControl('', validateEmail)
            });
          }

          //has list - no email, email not mandatory
          else if(this.hasUserList && !this.userListType){
            this.form = new FormGroup({
              identifier: new FormControl('', Validators.required),
              email: new FormControl('', validateEmail)
            });
          }

          // no list has a list of domains
          else if(!this.hasUserList && this.userListType && this.domainList != false){
            console.log(this.domainList[0])
            this.form = new FormGroup({
              identifier: new FormControl('', Validators.required),
              email: new FormControl(this.domainList[0].domain)
            });
          }

          //No list of users, no registered domains, no identifiers
          else if(!this.hasUserList && !this.domainList){
            this.form = new FormGroup({
              email: new FormControl('', validateEmail)
            });
          }

          else{
            //this.router.navigate(['page-not-found']);
          }

          this.setBackgroundColor(this.responseApis[0]['data']['generalDetails'][0]['background_color']);
          console.log(this.getBackgroundColor());
          this.backgroundColor = this.responseApis[0]['data']['generalDetails'][0]['background_color'];

          var questions= this.responseApis[0]['data']['questions'];
          for(var i = 0; i<questions.length; i++){
            console.log(questions[i]['order_in_quiz'], questions[i]);
            if(questions[i]['order_in_quiz'] == parseInt(this.route.params['_value'].index)){
              this.currentQuestion = questions[i];
              this.orderInQuiz = questions[i]['order_in_quiz'];
            }
            if(questions[i]['order_in_quiz'] == parseInt(this.route.params['_value'].index) + 1){
              this.nextQuestion = questions[i]['order_in_quiz'];
            }
          }
          this.lengthOfQuiz = questions;
          /*if(!this.currentQuestion){
           this.router.navigate(['page-not-found']);
           }*/

          this.slideIn = false;
          var m = this;
          setTimeout(function(){
            m.fadeOutLoader = true;
            m.logo = apiUrl + m.responseApis[0]['data']['logo'][0]['path'];
          }, 2000);
        }

      })
      .catch(error => this.error = error);
  }

  postAuthenticate(url: string, username:string): void {
    this.quizService
      .postAuthenticate(url, username)
      .then(responseApi => {
        this.loginAttempt = responseApi;
        console.log(this.loginAttempt);
        var thing = this;
        this.fadeOutLoaderLogin = true;
        console.log(thing.loginAttempt);
        setTimeout(function(){

          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt['msg'];
          localStorage.setItem('auth', thing.loginAttempt['token']);
          localStorage.setItem('hash', thing.loginAttempt['username']);
          console.log(thing.loginAttempt);
          //this.router.navigate(['page-not-found']);
        }, 1000);

      })
      .catch(error => this.error = error);
  }

  loginUser(){
    if(!this.form.valid){
      this.attemptToSubmit = false;
    }
    else{
      this.attemptToSubmit = true;
      var formValues = this.form.value;
      if(typeof formValues.identifier == 'undefined'){
        this.identifierForServer = formValues.email;
      }
      else{
        this.identifierForServer = formValues.identifier + '@' + formValues.email;
      }
      console.log(formValues);
      this.showLoaderLogin = true;
      this.textError = "";
      this.postAuthenticate(this.route.params['_value'].url, this.identifierForServer);
    }
  }

  markAnswer(elem:any){
    console.log(elem);
  }
  passToNextQuestion(){
    console.log()
    if(this.nextQuestion != false && this.nextQuestion != parseInt(this.route.params['_value'].index)){
      this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+ this.nextQuestion]);
    }
    else{
      console.log('this is the last question!!!!!!');
    }
  }
  updateAnswer(elem:any){
    this.quizService
      .updateAnswer(elem['question_id'], elem['id'], elem['rate'])
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){
          this.router.navigate([this.route.params['_value'].url+'/login']);
        }
        else{
          var m = this;
          setTimeout(function(){
            m.passToNextQuestion();
          }, 1000);
          this.slideIn = true;
          this.getUrl(this.route.params['_value'].url);
        }

      })
      .catch(error => this.error = error);
  }
  fadeOutAndPass(){
    //this.fadeInShow = false;
    this.fadeOut = true;
    var thing = this;
    setTimeout(function () {
      thing.router.navigate([thing.route.params['_value'].url+'/questionnaire/'+ thing.route.params['_value'].next+ '/'+thing.route.params['_value'].orientation]);
    }, 1000);
  }
  ngAfterViewChecked(){
    var thing = this;
    setTimeout(function () {
      thing.fadeInShow = true;
    }, 1000);
  }
  ngOnInit(): void {
    this.backgroundColor = '#ffffff'
    this.fadeOutLoader = false;
    this.logo = false;
    this.baseUrl = apiUrl;
    //this.getUrl(this.route.params['_value'].url);


    /*this.genericVal = this.route.params.subscribe(params => {
     const term = params['index'];
     this.getUrl(this.route.params['_value'].url);
     });*/
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/break8/break8.component.ts